export default {"src":"/_next/static/media/exel_is_creating_gt.dc1a0307.svg","height":154,"width":220};